<!--
 * @Author: ZhaoG
 * @Date: 2025-04-29 17:43:09
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-06-03 14:41:03
 * @FilePath: \gcp-fe\src\app\contactUs\views\networkAccessNotice.vue
 * @Description: 入网须知
-->
<template>
  <div class="contactUs">
    <div class="contentMain">
      <base-bread-crumb
        class="bread-crumb"
        :currBreadCrumb="currBreadCrumb"
        :isShowPortal="true"
      ></base-bread-crumb>
    </div>
    <div class="mainBox">
      <div class="contentMain">
        <div class="title">入网须知</div>
        <p>
          1.
          中国交通建设集团有限公司设备物资采购管理信息平台是供应商加入中国交通建设集团有限公司（以下简称“中国交建”）供应商网络的唯一合法网站。中国交建按照“互利共赢、诚信合作”的原则，与供应商建立积极的合作关系。
        </p>
        <p>
          2.
          中国交通建设集团有限公司对申请入网的供应商不收取任何费用，不颁发相关证书，也不以年审、会员制、业绩考核等名义向供应商收取费用。供应商填写入网信息必须真实、准确并及时更新。
        </p>
        <p>
          3.如遇系统升级，平台运营方有权延长招标结束时间、售标结束时间。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import BaseBreadCrumb from "../../noticesList/components/baseBreadCrumb";
export default {
  name: "announcement-list-revoked",
  components: {
    BaseBreadCrumb
  },
  data() {
    return {
      currBreadCrumb: [
        {
          title: "入网须知"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.contactUs {
  width: 100%;
  background: #eaeaea;

  .contentMain {
    width: 1180px;
    margin: 0 auto;
  }

  .mainBox {
    width: 100%;
    // height: 487px;
    background: #fff;
    padding-bottom: 20px;

    .title {
      width: 100%;
      padding: 20px 0;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 20px;
      color: #4a4a4a;
      border-bottom: 1px solid #eaeaea;
      margin-bottom: 20px;
    }

    p {
      // padding: 0 30px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #4a4a4a;
      margin-bottom: 20px;
      text-indent: 2em;
    }
  }
}

.bread-crumb {
  padding: 10px 0;
  margin: 0 !important;
}
</style>
